export enum MediaBrowser {
    PAGE = 'page',
    SELECTOR = 'selector'
}
  